<template>
  <ContextMenu
    close-on-outside-click
    :default-position
    :custom-position
    :custom-origin
  >
    <template v-if="options.length > 0" #facing="{ open, close, isOpen }">
      <slot v-bind="{ toggle: () => (isOpen ? close() : open()), isOpen }" />
    </template>
    <template #menu="{ close }">
      <div
        class="p-1 rounded-md bg-neutral-100 dark:bg-neutral-900 border border-neutral-300 dark:border-neutral-800"
      >
        <div
          v-if="header"
          class="px-2 pb-1 text-sm text-neutral-600 dark:text-neutral-400"
        >
          {{ header }}
        </div>
        <ul>
          <li v-for="option in options">
            <button
              class="w-full flex justify-between items-center gap-2 text-left p-1 rounded-md"
              :class="{
                'text-nami-comi-blue hover:bg-nami-comi-blue/20 hover:dark:bg-nami-comi-blue/30':
                  option.type === 'primary',
                'hover:bg-neutral-200 hover:dark:bg-neutral-700':
                  option.type === 'default',
                'text-red-500 hover:bg-red-300/50 dark:hover:bg-red-700/50':
                  option.type === 'danger',
              }"
              @click="
                (e) => {
                  option.action(e);
                  close();
                }
              "
            >
              <div class="flex items-center gap-2">
                <component v-if="option.icon" :size="20" :is="option.icon" />
                <span
                  :class="{
                    'mr-7': option.value !== active,
                  }"
                >
                  {{ option.text }}
                </span>
                <IconCheck
                  v-if="option.value === active"
                  class="text-nami-comi-blue"
                  :size="20"
                />
              </div>
            </button>
          </li>
        </ul>
      </div>
    </template>
  </ContextMenu>
</template>

<script setup lang="ts">
import { IconPlaceholder, IconCheck } from "@tabler/icons-vue";
import type { Props } from "./ContextMenu.vue";

export type Option = {
  type: "default" | "primary" | "danger";
  action: (event: MouseEvent) => any;
  text: string;
  value: string;
  icon?: typeof IconPlaceholder;
};

defineProps<{
  options: Option[];
  header?: string;
  active?: string;
  defaultPosition?: Props["defaultPosition"];
  customPosition?: Props["customPosition"];
  customOrigin?: Props["customOrigin"];
}>();
</script>
